<template>
    <div class="space-y-5 *:space-y-2 *:border-gray-200 *:border-2 *:p-3">
        <div typeof="schema:Review">
            <div class="flex justify-between">
                <p class="font-bold" rel="schema:author">
                            <span typeof="schema:Person">
                                <span property="schema:name" :content="review.name">
                                    {{ review.name }}
                                </span>
                            </span>
                </p>
                <p class="text-sm text-gray-400">{{ fromNow(review.created_at) }}</p>
            </div>

            <div v-if="review.rating" rel="schema:reviewRating">
                <div typeof="schema:Rating">
                    <div property="schema:ratingValue" :content="review.rating"></div>
                    <div property="schema:bestRating" content="5"></div>
                </div>
            </div>
            <Rating :rating="review.rating" />

            <div class="whitespace-pre-line">
                {{ review.content }}
            </div>

            <CommentReply v-if="showReply" :review="review" />
        </div>

        <div v-for="reply in review.replies" class="ml-5">
            <div class="flex justify-between">
                <p class="font-bold">{{ reply.is_company_answer ? product.company.title : reply.name }}</p>
                <p class="text-sm text-gray-400">{{ fromNow(reply.created_at) }}</p>
            </div>
            <div class="whitespace-pre-line">
                {{ reply.content }}
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Rating from '@/Components/Products/Rating.vue';
import CommentReply from '@/Partials/Products/Comments/CommentReply.vue';
import { fromNow } from '@/Helpers/dayjs.js';

export default defineComponent({
    components: { CommentReply, Rating },
    props: {
        product: Object,
        review: Object,
        showReply: {
            type: Boolean,
            default: true
        }
    },
    methods: { fromNow }
});
</script>
